import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Mediator } from '@spotahome/soyuz-mediator';
import Metrics from '@spotahome/soyuz-metrics';

import { addFavorite, removeFavorite } from '@gqlClient/mutations/favorites';
import { isLogged } from '@gqlClient/queries/user';
import getGqlClient from '@gqlClient/client';

import { OPEN_FAVORITE_CLAIM } from '../channels';

const openClaimModal = ({ data } = {}) => {
  if (data && !data.isLogged) {
    Mediator.publish(OPEN_FAVORITE_CLAIM);
  }
};

const withFavorites = () => WrappeddComponent => {
  class ComponentWithFavorites extends Component {
    static propTypes = {
      onToggleFavorite: PropTypes.func
    };

    static defaultProps = {
      onToggleFavorite: () => {}
    };

    state = {
      isFavorite: this.props.isFavorite
    };

    async markAsFavorite(rentableUnitId, prevIsFavorite) {
      try {
        const [isLoggedResponse] = await Promise.all([
          isLogged(getGqlClient())(),
          addFavorite(getGqlClient())(rentableUnitId)
        ]);

        openClaimModal(isLoggedResponse);

        Metrics.ga.sendEvent('favorite-button', 'enable-click');

        this.props.onToggleFavorite(rentableUnitId, true);
      } catch (error) {
        console.error(error);
        this.setState({ isFavorite: prevIsFavorite });
      }
    }

    async unmarkAsFavorite(rentableUnitId, prevIsFavorite) {
      try {
        await removeFavorite(getGqlClient())(rentableUnitId);

        Metrics.ga.sendEvent('favorite-button', 'disable-click');

        this.props.onToggleFavorite(rentableUnitId, false);
      } catch (error) {
        console.error(error);
        this.setState({ isFavorite: prevIsFavorite });
      }
    }

    handleFavorite = e => {
      e && e.preventDefault();
      const { isFavorite } = this.state;
      this.setState({ isFavorite: !isFavorite });

      if (isFavorite) {
        this.unmarkAsFavorite(this.props.id, isFavorite);
      } else {
        this.markAsFavorite(this.props.id, isFavorite);
      }
    };

    render() {
      return (
        <WrappeddComponent
          {...this.props}
          isFavorite={this.state.isFavorite}
          handleFavorite={this.handleFavorite}
        />
      );
    }
  }

  return ComponentWithFavorites;
};

export const withFavoritesShape = {
  isFavorite: PropTypes.bool.isRequired,
  handleFavorite: PropTypes.func.isRequired
};

export default withFavorites;
